import { render, staticRenderFns } from "./device.vue?vue&type=template&id=3801e8bf"
import script from "./device.vue?vue&type=script&lang=js"
export * from "./device.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports